/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { Avatar, Flex, Text, useToast } from '@chakra-ui/react'
import * as pdfjsReact from 'pdfjs-dist'
import 'pdfjs-dist/build/pdf.worker.entry'
import { useEffect, useState } from 'react'
import { FaBriefcase, FaBullseye, FaChartBar, FaChartLine, FaCog, FaFileAlt, FaFolderOpen, FaPlus, FaSave, FaUser, FaUserTie } from 'react-icons/fa'
import { MdClose } from 'react-icons/md'
import { useNavigate, useParams } from 'react-router-dom'
import { AccordionContainer } from '../../../../components/AccordionContainer'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import { ElementoTooltipCmp } from '../../../../components/ElementoTooltipCmp'
import { InputCmp } from '../../../../components/InputCmp'
import LoadingContainer from '../../../../components/LoadingContainer'
import { SwitchCmp } from '../../../../components/SwitchCmp'
import { TextAreaCmp } from '../../../../components/TextareaCmp'
import { WhiteContainer } from '../../../../components/WhiteContainer'
import { appApi } from '../../../../services/appApi'
import { UpdateElementByPosition } from '../../../../Utils/Helper'
import { Body } from '../../../Layouts/Body'
import { BoxArquivo } from '../components/BoxArquivo/BoxArquivo'
import { niveisAderencia3, niveisAderencia5, SelectAderencia } from './SelectAderencia'
import { DashedBox } from './styles'

interface iModel {
  nome: string
  nomeEmpresa: string
  nomeGestor: string
  urlAvatar: string
  aderencia: number
  aderencia5?: number
  aderenciaOriginal?: number
  aderencia5Original?: number
  logoEmpresa: string
  corEmpresa?: string
  percepcaoGeral: string[]
  pontosFortes: string[]
  pontosDeAtencao: string[]
  recomendacoes: string[]
  perfilPI: Perfil
  funcao: Funcao
  aderenciaFuncao: Aderencia
  curriculo: Curriculo
  nomeSolicitante: string
  emailSolicitante: string
  tipoCandidato: number
}

interface Perfil {
  urlAvatarSelo: string
  seloPi: string
  descricaoSelo: string
  descricao: string
  urlPDFPerfil: string
  urlPDFGuiaDesenvolvimentoPessoal: string
  urlPDFRelacionamentoGestor: string
  urlSelf: string
  urlSelfGestor: string
  descricaoFuncao: Funcao
  pontosDeAtencao: string[]
  pontosFortes: string[]
  estiloGestao: string[]
  sugestaoGestao: string[]
  sugestaoDesenvolvimento: string[]
}

interface Funcao {
  nome: string
  premissas: string
  descricao: string
  requisitos: string[]
  competencias: string[]
}

interface Curriculo {
  resumo: string
  resumoTecnico: string[]
  formacao: string[]
  experiencia: string[]
}

interface Aderencia {
  conhecimentoPontoForte: string[]
  conhecimentoPontoAtencao: string[]
  habilidadesPontoForte: string[]
  habilidadesPontoAtencao: string[]
  atitudesPontoForte: string[]
  atitudesPontoAtencao: string[]
}
export const EditarRelatorioCandidato: React.FC = () => {
  const nav = useNavigate()
  const toast = useToast()
  const { id } = useParams<{ id: string }>()
  const [Model, setModel] = useState<iModel>()
  const [AvatarTrocado, setAvatarTrocado] = useState(false)
  const [IsLoading, setIsLoading] = useState(false)
  const [ImageSelf, setImageSelf] = useState<string>('')
  const [ImageSelfGestor, setImageSelfGestor] = useState<string>('')
  const [descricaoCargo, setDescricaoCargo] = useState('')
  const [curriculo, setCurriculo] = useState('')
  const [quadroDesenvolvimento, setQuadroDesenvolvimento] = useState('')
  const [guiaRelacionamento, setGuiaRelacionamento] = useState('')
  const [PI, setPI] = useState('')
  const [RelatorioPerformance, setRelatorioPerformance] = useState('')

  function getModel(): void {
    setIsLoading(true)
    appApi.get(`api/SI/Relatorio/${id}?edit=True`)
      .then((res) => {
        setModel(res.data)
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function onEditar(): void {
    setIsLoading(true)
    appApi.post(`api/SI/${id}/Editar`, Model)
      .then(() => {
        if (
          guiaRelacionamento !== '' ||
          ImageSelfGestor !== '' ||
          descricaoCargo !== '' ||
          curriculo !== '' ||
          quadroDesenvolvimento !== '' ||
          ImageSelf !== '' ||
          PI !== '' ||
          RelatorioPerformance !== '' ||
          AvatarTrocado
        ) {
          onEditarDocumentos()
        } else {
          getModel()
          toast({
            title: 'Relatório editado com sucesso',
            duration: 4000,
            status: 'success',
            position: 'top'
          })
        }
      })
      .catch((err) => {
        setIsLoading(false)
        console.log(err)
        toast({
          title: 'Erro, tente novamente mais tarde',
          duration: 4000,
          status: 'error',
          position: 'top'
        })
      })
  }

  function onEditarDocumentos(): void {
    setIsLoading(true)
    const payload = {
      avatar: Model?.urlAvatar,
      descricaoCargo: descricaoCargo,
      pdfCurriculo: curriculo,
      guiaRelacionamentoGestor: guiaRelacionamento ?? '',
      quadroDesenvolvimento: quadroDesenvolvimento,
      imageSelf: ImageSelf,
      imageSelfGestor: ImageSelfGestor ?? '',
      pi: PI,
      performance: RelatorioPerformance
    }
    appApi.post(`api/SI/${id}/EditarDocumentos`, payload)
      .then(() => {
        getModel()
        toast({
          title: 'Relatório editado com sucesso',
          duration: 4000,
          status: 'success',
          position: 'top'
        })
      })
      .catch((err) => {
        setIsLoading(false)
        console.log(err)
        toast({
          title: 'Erro ao atualizar os documentos, tente novamente mais tarde',
          duration: 4000,
          status: 'error',
          position: 'top'
        })
      })
  }

  const handleFileCargoChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0]
    if (!file?.name.includes('.docx') && !file?.name.toLowerCase().includes('.pdf')) {
      toast({
        title: 'O arquivo deve ser no formato ".docx" ou ".PDF" para ser aceito',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      event.target.value = ''
      return
    }
    if (file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        setDescricaoCargo(reader.result as string)
      }
    }
  }
  const handleFileCurriculoChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0]
    if (!file?.name.toLowerCase().includes('.pdf')) {
      toast({
        title: 'O arquivo deve ser no formato ".PDF" para ser aceito',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      event.target.value = ''
      return
    }
    if (file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        setCurriculo(reader.result as string)
      }
    }
  }
  const handleFilePiChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0]
    if (!file?.name.toLowerCase().includes('.pdf')) {
      toast({
        title: 'O arquivo deve ser no formato ".PDF" para ser aceito',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      event.target.value = ''
      return
    }
    if (file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        setPI(reader.result as string)
      }
    }
  }

  const handleFilePerformanceChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0]
    if (!file?.name.includes('.docx') && !file?.name.toLowerCase().includes('.pdf')) {
      toast({
        title: 'O arquivo deve ser no formato ".docx" ou ".PDF" para ser aceito',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      event.target.value = ''
      return
    }
    if (file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        setRelatorioPerformance(reader.result as string)
      }
    }
  }

  const handleFilePiGestorChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0]
    if (!file?.name.toLowerCase().includes('.pdf')) {
      toast({
        title: 'O arquivo deve ser no formato ".PDF" para ser aceito',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      event.target.value = ''
      return
    }
    if (file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        convertPDFToImages(reader.result as string, true)
      }
    }
  }

  const convertPDFToImages = async (PDF: string, isGestor: boolean) => {
    try {
      const pdf = await pdfjsReact.getDocument(PDF).promise

      const page = await pdf.getPage(1)
      const scale = 2
      const viewport = page.getViewport({ scale })

      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')

      if (!context) return

      canvas.width = viewport.width
      canvas.height = viewport.height

      await page.render({ canvasContext: context, viewport }).promise

      // Criar um novo canvas para recorte
      const croppedCanvas = document.createElement('canvas')
      const croppedContext = croppedCanvas.getContext('2d')

      if (!croppedContext) return

      const cropHeight = viewport.height * 0.18
      const cropWidth = viewport.width * 0.9
      const startX = (viewport.width - cropWidth) / 2
      const startY = viewport.height * 0.245

      croppedCanvas.width = cropWidth
      croppedCanvas.height = cropHeight

      croppedContext.drawImage(
        canvas,
        startX, startY, cropWidth, cropHeight,
        0, 0, cropWidth, cropHeight
      )

      if (isGestor) {
        setImageSelfGestor(croppedCanvas.toDataURL('image/png'))
      } else {
        setImageSelf(croppedCanvas.toDataURL('image/png'))
      }
    } catch (error) {
      console.error('Erro ao converter PDF:', error)
    }
  }

  const handleFilePiQuadro = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0]
    if (!file?.name.toLowerCase().includes('.pdf')) {
      toast({
        title: 'O arquivo deve ser no formato ".PDF" para ser aceito',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      event.target.value = ''
      return
    }
    if (file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        setQuadroDesenvolvimento(reader.result as string)
      }
    }
  }
  const handleFilePiRelacionamento = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0]
    if (!file?.name.toLowerCase().includes('.pdf')) {
      toast({
        title: 'O arquivo deve ser no formato ".PDF" para ser aceito',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      event.target.value = ''
      return
    }
    if (file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        setGuiaRelacionamento(reader.result as string)
      }
    }
  }

  const handleAvatar = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0]

    if (!file?.type.startsWith('image/')) {
      toast({
        title: 'O arquivo deve ser uma imagem (jpg, png, webp...)',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      event.target.value = ''
      return
    }

    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      if (Model) {
        setModel({ ...Model, urlAvatar: reader.result as string })
        setAvatarTrocado(true)
      }
    }
  }

  function renderArrayField(label: string, values: string[], onChange: (updated: string[]) => void, max?: number): any {
    return (
      <AccordionContainer title={label}>
        {renderArrayItems(label, values, onChange, max)}
      </AccordionContainer>
    )
  }

  function renderArrayItems(label: string, values: string[], onChange: (updated: string[]) => void, max?: number): any {
    return (
        <Flex direction='column' gap='1rem'>
          <h3>{label}</h3>
          {values.map((item, index) => (
            <Flex key={index} gap='0.5rem'>
              <InputCmp
                value={item}
                OnChange={e => onChange(UpdateElementByPosition(values ?? [], index, e))}
              />
              <ElementoTooltipCmp label='Remover item' bg={'var(--Red)'}>
                <ButtonCmp VarColor='Red' onClick={() => {
                  const updated = [...(values ?? [])]
                  updated.splice(index, 1)
                  onChange(updated)
                }}>
                  <MdClose/>
                </ButtonCmp>
              </ElementoTooltipCmp>
            </Flex>
          ))}
          {max !== undefined && <Text fontSize='0.8rem' color='#606060'>Máximo de {max} itens</Text>}
          {(max === undefined || values.length < max) && <ButtonCmp leftIcon={<FaPlus/>} VarColor='Green2' onClick={() => onChange([...(values ?? []), ''])}>
            Adicionar
          </ButtonCmp>}
        </Flex>
    )
  }

  function renderAderenciaGrupo(titulo: string, forte: keyof Aderencia, atencao: keyof Aderencia): any {
    if (!Model) return null
    const atualiza = (chave: keyof Aderencia, updated: string[]): void => setModel({ ...Model, aderenciaFuncao: { ...Model.aderenciaFuncao, [chave]: updated } })
    return (
      <AccordionContainer title={titulo}>
        <Flex direction='column' gap='1rem'>
          {renderArrayItems('Pontos fortes', Model.aderenciaFuncao[forte] ?? [], updated => atualiza(forte, updated), 3)}
          {renderArrayItems('Potenciais pontos de atenção', Model.aderenciaFuncao[atencao] ?? [], updated => atualiza(atencao, updated), 3)}
        </Flex>
      </AccordionContainer>
    )
  }

  useEffect(() => {
    getModel()
  }, [])

  return (
    <Body isLoading={IsLoading}>
      {!Model && <LoadingContainer linhas={32} loading={true}></LoadingContainer>}
      {Model && <WhiteContainer margin='1rem 0'>
        <Flex justifyContent={'space-between'} alignItems={'center'}>
          <h1>Editar relatório PRISMAH</h1>
          <SwitchCmp OnChange={(val) => val ? setModel({ ...Model, tipoCandidato: 1 }) : setModel({ ...Model, tipoCandidato: 0 }) } legendaEsquerda='Candidato Interno' legendaDireita='Candidato Externo' value={Model.tipoCandidato === 1}/>
        </Flex>
        <Flex direction='column' gap='1rem'>
          <Flex justifyContent={'center'} alignItems='center' flexDir={'column'}>
            <Text fontWeight={600}>Avatar do candidato</Text>
            <DashedBox htmlFor='m-file'>
              <Avatar src={Model.urlAvatar} w={'110px'} h={'110px'}/>
              <small>Clique para selecionar</small>
              <input
                id='m-file'
                onChange={(e) => { handleAvatar(e) }}
                type={'file'}
              />
            </DashedBox>
          </Flex>
          <AccordionContainer grupo icone={<FaChartBar/>} title='Dados gerais'>
            <Flex direction='column' gap='1rem'>
              <h3>Dados gerais</h3>
              <InputCmp label='Nome' value={Model.nome} OnChange={e => setModel({ ...Model, nome: e })} />
              <InputCmp label='Nome da empresa' value={Model.nomeEmpresa} OnChange={e => setModel({ ...Model, nomeEmpresa: e })} />
              <InputCmp label='Nome do gestor' value={Model.nomeGestor} OnChange={e => setModel({ ...Model, nomeGestor: e })} />
              {/* <InputCmp label='URL do avatar' value={Model.urlAvatar} OnChange={e => setModel({ ...Model, urlAvatar: e })} />
              <InputCmp label='Logo da empresa' value={Model.logoEmpresa} OnChange={e => setModel({ ...Model, logoEmpresa: e })} /> */}
              <InputCmp label='Cor da empresa' value={Model.corEmpresa ?? ''} OnChange={e => setModel({ ...Model, corEmpresa: e })} />
              <InputCmp label='Nome do solicitante' value={Model.nomeSolicitante ?? ''} OnChange={e => setModel({ ...Model, nomeSolicitante: e })} />
              <InputCmp label='Email do solicitante' value={Model.emailSolicitante ?? ''} OnChange={e => setModel({ ...Model, emailSolicitante: e })} />
            </Flex>
          </AccordionContainer>

          <AccordionContainer grupo icone={<FaUser/>} title='Resumo do profissional'>
            <Flex direction='column'>
              <AccordionContainer title='Nível de aderência'>
                <Flex direction='column' gap='1rem'>
                  <h3>Nível de aderência</h3>
                  <SelectAderencia label='Aderência' niveis={niveisAderencia3} value={Model.aderencia} original={Model.aderenciaOriginal} OnChange={e => setModel({ ...Model, aderencia: e })} />
                  <SelectAderencia label='Aderência (escala 5)' niveis={niveisAderencia5} value={Model.aderencia5} original={Model.aderencia5Original} OnChange={e => setModel({ ...Model, aderencia5: e })} />
                </Flex>
              </AccordionContainer>
              <AccordionContainer title='Percepção Geral'>
                <Flex direction='column' gap='1rem'>
                  <h3>Percepção Geral</h3>
                  <TextAreaCmp label='Nome' value={Model.percepcaoGeral[0]} OnChange={e => setModel({ ...Model, percepcaoGeral: [e] })} />
                </Flex>
              </AccordionContainer>
              {renderArrayField('Pontos Fortes', Model.pontosFortes, updated => setModel({ ...Model, pontosFortes: updated }))}
              {renderArrayField('Pontos de Atenção', Model.pontosDeAtencao, updated => setModel({ ...Model, pontosDeAtencao: updated }))}
              {renderArrayField('Recomendações', Model.recomendacoes, updated => setModel({ ...Model, recomendacoes: updated }))}
            </Flex>
          </AccordionContainer>

          <AccordionContainer grupo icone={<FaFileAlt/>} title='Premissas da vaga'>
            <Flex direction='column'>
              <AccordionContainer title='Função'>
                <Flex direction='column' gap='1rem'>
                  <h3>Função</h3>
                  <InputCmp label='Nome da função' value={Model.funcao.nome} OnChange={e => setModel({ ...Model, funcao: { ...Model.funcao, nome: e } })} />
                  <TextAreaCmp label='Premissas' value={Model.funcao.premissas} OnChange={e => setModel({ ...Model, funcao: { ...Model.funcao, premissas: e } })} />
                </Flex>
              </AccordionContainer>
              <AccordionContainer title='Descritivo do cargo'>
                <Flex direction='column' gap='1rem'>
                  <h3>Descritivo do cargo</h3>
                  <TextAreaCmp label='Resumo descrição da função' value={Model.funcao.descricao} OnChange={e => setModel({ ...Model, funcao: { ...Model.funcao, descricao: e } })} />
                  {renderArrayItems('Requisitos', Model.funcao.requisitos ?? [], updated => setModel({ ...Model, funcao: { ...Model.funcao, requisitos: updated } }))}
                  {renderArrayItems('Competências desejáveis', Model.funcao.competencias ?? [], updated => setModel({ ...Model, funcao: { ...Model.funcao, competencias: updated } }))}
                </Flex>
              </AccordionContainer>
            </Flex>
          </AccordionContainer>

          <AccordionContainer grupo icone={<FaBriefcase/>} title='Dados pessoais e experiência'>
            <Flex direction='column'>
              <AccordionContainer title='Currículo'>
                <Flex direction='column' gap='1rem'>
                  <h3>Currículo</h3>
                  <TextAreaCmp label='Resumo' value={Model.curriculo.resumo} OnChange={e => setModel({ ...Model, curriculo: { ...Model.curriculo, resumo: e } })} />
                </Flex>
              </AccordionContainer>
              {renderArrayField('Resumo Técnico', Model.curriculo.resumoTecnico, updated => setModel({ ...Model, curriculo: { ...Model.curriculo, resumoTecnico: updated } }))}
              {renderArrayField('Formação', Model.curriculo.formacao, updated => setModel({ ...Model, curriculo: { ...Model.curriculo, formacao: updated } }))}
              {renderArrayField('Experiência', Model.curriculo.experiencia, updated => setModel({ ...Model, curriculo: { ...Model.curriculo, experiencia: updated } }))}
            </Flex>
          </AccordionContainer>

          <AccordionContainer grupo icone={<FaBullseye/>} title='Aderência à função'>
            <Flex direction='column'>
              {renderAderenciaGrupo('Conhecimento', 'conhecimentoPontoForte', 'conhecimentoPontoAtencao')}
              {renderAderenciaGrupo('Habilidades', 'habilidadesPontoForte', 'habilidadesPontoAtencao')}
              {renderAderenciaGrupo('Atitudes', 'atitudesPontoForte', 'atitudesPontoAtencao')}
            </Flex>
          </AccordionContainer>

          <AccordionContainer grupo icone={<FaUserTie/>} title='Perfil comportamental'>
            <Flex direction='column'>
              {renderArrayField('Pontos fortes', Model.perfilPI?.pontosFortes ?? [], updated => setModel({ ...Model, perfilPI: { ...Model.perfilPI, pontosFortes: updated } }), 6)}
              {renderArrayField('Pontos de atenção', Model.perfilPI?.pontosDeAtencao ?? [], updated => setModel({ ...Model, perfilPI: { ...Model.perfilPI, pontosDeAtencao: updated } }), 6)}
            </Flex>
          </AccordionContainer>

          <AccordionContainer grupo icone={<FaCog/>} title='Estilos de gestão'>
            <Flex direction='column'>
              {renderArrayField('Como líder de pessoas ou projetos', Model.perfilPI?.estiloGestao ?? [], updated => setModel({ ...Model, perfilPI: { ...Model.perfilPI, estiloGestao: updated } }))}
            </Flex>
          </AccordionContainer>

          <AccordionContainer grupo icone={<FaChartLine/>} title='Sugestões de gestão e desenvolvimento'>
            <Flex direction='column'>
              {renderArrayField('Sugestões para gestão (Ao liderar o profissional)', Model.perfilPI?.sugestaoGestao ?? [], updated => setModel({ ...Model, perfilPI: { ...Model.perfilPI, sugestaoGestao: updated } }))}
              {renderArrayField('Sugestões de desenvolvimento', Model.perfilPI?.sugestaoDesenvolvimento ?? [], updated => setModel({ ...Model, perfilPI: { ...Model.perfilPI, sugestaoDesenvolvimento: updated } }))}
            </Flex>
          </AccordionContainer>

          <AccordionContainer grupo icone={<FaFolderOpen/>} title='Documentos'>
            <Flex flexDir={'column'} gap={'1.75rem'} mt={'1rem'}>
            <Text fontWeight={700} fontSize={'18px'}>Adicione apenas os arquivos que desejar alterar</Text>
            <Flex alignItems={'center'} justifyContent={'space-between'} flexWrap={'wrap'}>
              <BoxArquivo
                title='Currículo'
                isOpcional={false}
                AtualizarArquivo={handleFileCurriculoChange}
                id={'fileCurriculo'}
                tipo={1}
              />
              <BoxArquivo
                isOpcional={false}
                title='Descrição da vaga'
                AtualizarArquivo={handleFileCargoChange}
                id={'fileCargo'}
                tipo={2}
              />
              <BoxArquivo
                isOpcional={false}
                title='PI - Guia de relacionamento'
                AtualizarArquivo={handleFilePiRelacionamento}
                id={'filePIRelacionamento'}
                tipo={1}
              />
            </Flex>
            <Flex alignItems={'center'} justifyContent={'space-between'} flexWrap={'wrap'}>
              <BoxArquivo
                title='PI'
                isOpcional={false}
                AtualizarArquivo={handleFilePiChange}
                id={'filePI'}
                tipo={1}
              />
              <BoxArquivo
                isOpcional={false}
                title='PI - Quadro de desenvolvimento'
                AtualizarArquivo={handleFilePiQuadro}
                id={'filePIQuadro'}
                tipo={1}
              />
              <BoxArquivo
                isOpcional={false}
                title='PI do Gestor'
                AtualizarArquivo={handleFilePiGestorChange}
                id={'filePIGestor'}
                tipo={1}
              />
            </Flex>
            <Flex alignItems={'center'} justifyContent={'start'} flexWrap={'wrap'} gap={'3rem'}>
              <BoxArquivo
                title='Relatório de performance'
                isOpcional={false}
                AtualizarArquivo={handleFilePerformanceChange}
                id={'filePerformance'}
                tipo={1}
              />
            </Flex>
          </Flex>
          </AccordionContainer>

          <Flex justifyContent={'end'} gap='1rem'>
            <ButtonCmp VarColor='c6' onClick={() => nav(-1)}>Voltar</ButtonCmp>
            <ButtonCmp VarColor='Green2' onClick={onEditar} leftIcon={<FaSave/>}>Salvar</ButtonCmp>
          </Flex>
        </Flex>
      </WhiteContainer>}
    </Body>
  )
}

export default EditarRelatorioCandidato
